// extracted by mini-css-extract-plugin
export default {"image":"ErrorRecommender-module__image-QJ33gG","wrapper":"ErrorRecommender-module__wrapper-WXE179","content":"ErrorRecommender-module__content-h2ni2Q"};